import React, {useEffect, useState} from 'react';
import {Grid, InputBase, Select} from "@material-ui/core";
import MenuItem from "@material-ui/core/MenuItem";
import {current_term, current_year, terms} from "../../../constants";
import {makeStyles} from "@material-ui/core/styles";
import api from "../../../api/api";
import {setUserData} from "../../../actions/accountActions";
import {toast} from "react-toastify";
import {useDispatch, useSelector} from "react-redux";
import {useHistory, useLocation} from "react-router";

const useStyles = makeStyles(() => ({
    termContainer: {
        backgroundColor: "#f4f6f8",
        zIndex: 40,
        position: 'fixed',
        top: 64,
        width: '100%',
        paddingLeft: 40,
        paddingTop: 8,
        paddingBottom: 12
    },
    textField: {
        paddingTop: 10,
        paddingBottom: 10,
        border: "none",
        width: 180,
        background: "#E9ECF0",
        borderRadius: 12,
        fontSize: 16,
    },
    select: {
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: 'red',
        },
    },

    noBorder: {
        "& .MuiOutlinedInput-notchedOutline": {
            border: "none", // убираем рамку
        },
        "&:hover .MuiOutlinedInput-notchedOutline": {
            border: "none", // убираем при ховере
        },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            border: "none", // убираем при фокусе
        },
    },
}))

const getYearsList = () => {
    // july
    const studyYearStartMonth = 6
    const firstYear = 2019

    const hasMoreYear = (year, now) => now.getFullYear() > year ||
        (now.getFullYear() === year && now.getMonth() >= studyYearStartMonth)

    const getStudyYearObject = (year) => ({value: `${year}/${year + 1}`, name: `${year}/${year + 1}`})

    const getYearRecursive = (year, result) => {
        if (hasMoreYear(++year, new Date()))
            return getYearRecursive(year, [...result, getStudyYearObject(year)])

        return result
    }

    return getYearRecursive(firstYear, [getStudyYearObject(firstYear)])
}

const TermChange = () => {
    const [personalYear, setPersonalYear] = useState('');
    const [personalTerm, setPersonalTerm] = useState('');
    const account = useSelector((state) => state.account);
    const {user} = account;
    const {systemConfig} = useSelector(state => state)

    const classes = useStyles();
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();

    useEffect(() => {
        if (user) {
            if (user?.selected_year) {
                setPersonalYear(user?.selected_year)
            }

            if (user?.selected_term !== null) {
                setPersonalTerm(user?.selected_term);
            }

            if (user?.personal_config?.find(x => x.name === current_term)?.value) {
                setPersonalTerm(user?.personal_config?.find(x => x.name === current_term)?.value)
            }

            if (user?.personal_config?.find(x => x.name === current_year)?.value) {
                setPersonalYear(user?.personal_config?.find(x => x.name === current_year)?.value)
            }
        }
    }, [user])

    const handleYearChange = (value) => {
        setPersonalYear(value);
        switchTermAndYear({year: value});
    }

    const handlePersonalTermChange = (value) => {
        setPersonalTerm(value);
        switchTermAndYear({term: value})
    }

    const switchTermAndYear = ({year, term}) => {
        const dataTerm = {
            name: "current_term",
            value: term ?? personalTerm
        }

        const dataYear = {
            name: "current_year",
            value: year ?? personalYear
        }

        api.setPersonalConfig(dataTerm)
            .then(() => {
                dispatch(setUserData());
            })
            .catch(() => toast.error("Не удалось изменить семестр/год"))
            .finally(() => {
                api.setPersonalConfig(dataYear)
                    .then(() => {
                        dispatch(setUserData());
                        if (location.pathname.includes('journal')) {
                            history.push('/bars/journal');
                        }
                        history.go();
                    })
            })
    }

    const renderYearName = (item) => {
        return systemConfig?.config?.find(x => x.name === current_year)?.value === item.value
            ? item.name + " (текущий)"
            : item.name
    }

    return (
        <div className={classes.termContainer}>
            <Grid container direction={"row"} alignItems={"flex-end"} alignContent={"center"} spacing={3}>
                <Grid item>
                    <Select
                        classes={{root: classes.textField}}
                        className={classes.noBorder}
                        id={"term_select"}
                        placeholder={"Семестр"}
                        name="Семестр"
                        value={personalTerm}
                        onChange={(e) => handlePersonalTermChange(e.target.value)}
                        variant={"outlined"}
                    >
                        {terms.map(item =>
                            <MenuItem
                                key={item.id}
                                value={item.value}
                            >
                                {item.name}
                            </MenuItem>
                        )}
                    </Select>
                </Grid>
                <Grid item>
                    <Select
                        classes={{root: classes.textField}}
                        className={classes.noBorder}
                        id={"year_select"}
                        placeholder={"Год"}
                        fullWidth
                        name="Год"
                        value={personalYear}
                        onChange={(e) => handleYearChange(e.target.value)}
                        variant={"outlined"}
                    >
                        {getYearsList().map(item =>
                            <MenuItem
                                key={item.value}
                                value={item.value}
                            >
                                {renderYearName(item)}
                            </MenuItem>
                        )}
                    </Select>
                </Grid>
            </Grid>
        </div>
    );
}

export default TermChange;
